import { render, staticRenderFns } from "./Produits.vue?vue&type=template&id=44358f35&scoped=true"
import script from "./Produits.vue?vue&type=script&lang=js"
export * from "./Produits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44358f35",
  null
  
)

export default component.exports